import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { CarouselImage } from "cms/components/components/hero-carousel/display/carousel-image";
import { RichTextPreview } from "cms/rich-text/simplicity-composer-tiptap/index";

const HeroCarouselSlide = (props) => {
    
    const images = props?.images;
    const slides = props?.slides;
    const index = props?.index;
    const total = props?.total;
    const moveIndex = props?.moveIndex;
    
    const slide = slides[index];
    
    // slide
    const title = slide?.title;
    const description = slide?.description;
    const link = slide?.link;
    const slideImage = slide?.image;
    
    const settings = slideImage?.settings;
    
    // link
    const text = link?.text;
    const link_url = link?.url;
    
    const image = Array.isArray(images) && images[index];
    
    return (
        <div className={"carousel-slide"}>
            
            <div className="home-banner">
                <CarouselImage
                    image={image}
                    slide={slide}
                    settings={settings}
                />
            </div>
            
            <div className="home-banner-content">
                
                <div className='carousel-slide-title'>{title}</div>
                
                <RichTextPreview
                    richtext={description}
                    className='carousel-slide-description'
                />
                
                <div className="controls">
                    
                    {link_url &&
                        <Link to={link_url} className='carousel-slide-link'>
                            {text}
                        </Link>
                    }
                    
                    <div className="forward-back">
                        <button
                            aria-label="Previous"
                            onClick={() => moveIndex(-1)}
                        >
                            <FontAwesomeIcon icon={"fa-regular fa-arrow-left"}/>
                        </button>
                        
                        <span>{`${index + 1}/${total}`}</span>
                        
                        <button
                            aria-label="Next"
                            onClick={() => moveIndex(1)}
                        >
                            <FontAwesomeIcon icon={"fa-regular fa-arrow-right"}/>
                        </button>
                    </div>
                </div>
            </div>
        
        </div>
    );
};

export { HeroCarouselSlide };
